import { searchAutocomplete } from '../../api/searchAPI';
import { debounce } from '../../utils/debounce';

// Response is either a plain list, or { suggestions, recentSearches }
// when withRecent was asked for.
const applyResult = (res, setAutoCompleteData, setRecentSearches) => {
    const data = res?.data;

    if (data && !Array.isArray(data) && Array.isArray(data.suggestions)) {
        setAutoCompleteData(data.suggestions);
        if (typeof setRecentSearches === 'function') setRecentSearches(data.recentSearches || []);
        return;
    }

    setAutoCompleteData(data || []);
};

export const handleAutoComplete = async ({
    type,
    value = '',
    setAutoCompleteData,
    setRecentSearches,
    withRecent = false,
    limit,
    catlim,
    place = '',
    activity
}) => {
    try {
        /*
        ============================================================
        TRIP
        ============================================================

        Keep existing trip autocomplete exactly as it is.
        */

        if (type !== 'act') {
            const res = await searchAutocomplete({
                type,
                withRecent,
                value,
                place,
                activity,
                limit,
                catlim
            });

            applyResult(res, setAutoCompleteData, setRecentSearches);

            return;
        }
        /*
        ============================================================
        ACTIVITY
        ============================================================

        Only activity search uses the new place/activity logic.
        */

        // PLACE AUTOCOMPLETE
        // activity is undefined when called from place input.
        // NOTE: we no longer bail out when place is empty - an
        // empty place (e.g. on initial focus/click) is forwarded
        // to the backend, which returns default/trending city
        // suggestions for that case.
        if (activity === undefined) {
            const res = await searchAutocomplete({
                type,
                withRecent,
                place: place.trim(),
                limit
            });

            applyResult(res, setAutoCompleteData, setRecentSearches);

            return;
        }

        // ACTIVITY AUTOCOMPLETE
        // activity can be empty when activity input is focused.
        // NOTE: we no longer bail out when place is empty either -
        // an empty place + empty activity (e.g. clicking the
        // activity field before choosing a place) is forwarded to
        // the backend, which returns default/trending activity
        // suggestions for that case.
        const res = await searchAutocomplete({
            type,
            withRecent,
            place: place.trim(),
            activity: activity.trim(),
            limit
        });

        applyResult(res, setAutoCompleteData, setRecentSearches);
    } catch (error) {
        console.error('Error fetching autocomplete data:', error);

        setAutoCompleteData([]);
    }
};

// Shorter wait so suggestions appear quicker (results are cached too)
export const debouncedHandleAutoComplete = debounce(handleAutoComplete, 300);
